import Swal from "sweetalert2";
import { useFetch } from "../../../common/hooks/useFetch";
import { approveSurveyService } from "../services/approveSurvey.service";
import { useState } from "react";
import { updateSurveyService } from "../services/updateSurvey.service";

export const useSurveyCommand = (refresh) => {
  const fetchData = useFetch();
  const [loading, setLoading] = useState(false);

  const approveSurvey = async (survery) => {
    try {
      setLoading(true);
      await approveSurveyService(fetchData)(survery);
      refresh?.();
      Swal.fire("Éxito", "Encuesta aprobada correctamente", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const updateSurvey = async (survey) => {
    try {
      setLoading(true);
      await updateSurveyService(fetchData)(survey);
      refresh?.();
      Swal.fire("Éxito", "Encuesta actualizada correctamente", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    approveSurvey,
    updateSurvey,   
    loading,
  };
};
